/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agency_Pointfour1Inputs */

const ja_home_agency_pointfour1 = /** @type {(inputs: Home_Agency_Pointfour1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINの実績を見る`)
};

const en_home_agency_pointfour1 = /** @type {(inputs: Home_Agency_Pointfour1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn about what we do`)
};

/**
* | output |
* | --- |
* | "Learn about what we do" |
*
* @param {Home_Agency_Pointfour1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_agency_pointfour1 = /** @type {((inputs?: Home_Agency_Pointfour1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agency_Pointfour1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_agency_pointfour1(inputs)
	return en_home_agency_pointfour1(inputs)
});
export { home_agency_pointfour1 as "home_agency_pointFour" }